import NoData from '@monorepo/common/component/NoData';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import ResponsiveHeaderRow from '@monorepo/common/component/responsive/ResponsiveHeaderRow';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { ClientDocument, ClientQuery, ClientQueryVariables } from '../../graphql-operations';
import ClientDetailView, { NewClientIcon } from './ClientDetailView';

interface ClientDetailProps {
  clientId?: string;
  listUrl: string;
}

export default function ClientDetail({ clientId, listUrl }: ClientDetailProps) {
  return (
    <>
      {/*Top header for small screens to go back to list*/}
      <ResponsiveHeaderRow to={listUrl}>
        <NewClientIcon />
      </ResponsiveHeaderRow>

      {!!clientId && (
        <QueryWithLoader<ClientQuery, ClientQueryVariables> query={ClientDocument} variables={{ id: clientId }}>
          {({ data }) => {
            const client = data.client;

            if (!client) {
              return <Redirect to="/page-not-found" />;
            }

            return <ClientDetailView client={client} />;
          }}
        </QueryWithLoader>
      )}

      {!clientId && <NoData text="Vyberte člena" />}
    </>
  );
}
